<template>
  <div class="all-style-bgc">
    <div class="container">
      <div class="title-tab">
        <span>当前位置：</span>
        <span @click="GoreportInternet">审查调查></span>
        <span @click="GoreportEvaluation">党纪政务处分></span>
        <span class="red">正文</span>
      </div>
      <!--正文内容-->
      <div class="text">
        <h1>海南省委原常委、海口市委原书记张琦严重违纪违法被开除党籍和公职</h1>
        <div class="first">
        <span class="third">来源：新华社</span>
         <span class="si">|</span>
        <span>发布时间：2020-5-20 13:30</span>
      </div>
      <div class="xh"></div>
        <h3 class="yi">日前，经中共中央批准，中央纪委国家监委对海南省委原常委、海口市委原书记张琦严重违纪违法问题进行了立案审查调查。</h3>
        <h3>　经查，张琦丧失理想信念和党性原则，背弃初心使命，背离新发展理念，落实党中央重大决策部署不坚决、不到位；对党不忠诚、不老实，处心积虑对抗组织审查，不按规定报告个人有关事项，在组织谈话时不如实说明问题；违反中央八项规定精神，多次接受不法私营企业主的宴请和旅游安排；收受礼品、礼金；将公权力作为谋取私利的工具，在工程项目承揽、土地征收拆迁、干部职务晋升等方面利用职务上的便利为他人谋利，并非法收受巨额财物；家风败坏，伙同家人大肆收钱敛财、大搞权钱交易。.11%。从村（社区）干部受处理具体案例来分析，两人或两人以上“抱团”违纪现象比较普遍。主要表现为以村支部书记、主任为核心，其他村组干部参与、共同“谋划”的利益“小团体”，成为违纪违法问题的高危群体。如，该市太平镇崔垱村、大王村从村支部书记到村委会委员，集体挪用粮食直补款、坐收坐支集体资金等，涉及村“两委”干部达5人。+体会交流+廉政党课”的方式召开了“一案一教育”警示教育大会，强化警示教育的感染力和说服力。</h3>
        <h3>张琦严重违反党的政治纪律、组织纪律、廉洁纪律、工作纪律和生活纪律，构成严重职务违法并涉嫌受贿犯罪，是党的十八大后不收敛、不收手的腐败典型，性质严重、影响恶劣，应予严肃处理。依据《中国共产党纪律处分条例》《中华人民共和国监察法》等有关规定，经中央纪委常委会会议研究并报中共中央批准，决定给予张琦开除党籍处分；由国家监委给予其开除公职处分；终止其党的十九大代表、海南省第七次党代会代表、海口市第十三次党代会代表资格；收缴其违纪违法所得；将其涉嫌犯罪问题移送检察机关依法审查起诉，所涉财物随案移送。-2018年在担任该所党支部书记、所长期间，违反中央八项规定精神、违反政治纪律、挪用公款、非法占有公共财物等，被群众多次举报。其中违反中央八项规定精神达3次之多，从党内警告处分直至给予留党察看。分析多次被举报受处分人员情况，国家工作人员71人，农村党员干部108人。其中村（社区）主职干部被举报频率较高，受处分达72人，占比40.22%。</h3>
        <h3>
          <b>　张琦简历 </b>
        </h3>
        <h3>　张琦，男，1961年3月生，汉族，安徽寿县人，在职研究生学历，工学硕士、高级管理人员工商管理硕士学位，1981年8月参加工作，1983年6月加入中国共产党。</h3>
        <h3>　1979.09 淮南师范专科学校数学系数学专业学习</h3>
        <h3>　1981.08 淮南师范专科学校团委干事、副书记、书记</h3>
        <h3>　1988.08 煤炭部淮南矿务局南方公司副经理</h3>
        <h3>　1991.10 海南省农业综合开发实验区管委会工商处负责人、处长</h3>

        <h3>　1993.03 海南省农业综合开发实验区管委会工商局局长</h3>
        <h3>（1992.02-1993.12天津大学管理系工商管理专业学习）</h3>
        <h3>　　1997.02 海南省工商行政管理局副局长</h3>
        <h3>　2000.10 海南省工商行政管理局副局长、纪检组组长</h3>
        <h3>　2003.02 海南省三亚市委常委、副市长</h3>
        <h3>　2004.06 海南省三亚市委副书记、副市长</h3>
        <h3>　　2006.05 海南省旅游局局长</h3>
        <h3>　　2008.08 海南省儋州市委副书记、代市长、市长（正厅级）</h3>
        <h3>　2010.02 海南省儋州市委书记，兼洋浦经济开发区工委副书记（正厅级，其间：2011.03 -2011.10兼任儋州市人大常委会主任）</h3>
        <h3>（2008.05-2010.09长江商学院高级管理人员工商管理硕士班学习）</h3>
        <h3>　2014.09 海南省委常委、儋州市委书记，兼洋浦经济开发区工委副书记</h3>
        <h3>　2014.10 海南省委常委、三亚市委书记</h3>
        <h3>　2016.11 海南省委常委、海口市委书记（简历摘自人民网）</h3>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {};
  },
  methods: {
     GoreportInternet() {
      this.$router.push("/Investigate");
    },
    GoreportEvaluation() {
      this.$router.push("/Investigate/DangJi" );
    },
  }
};
</script>

<style lang="less" scoped>
.si{
   margin: 0 16px;
 }
.first {
  text-align: center;
  font-size: 16px;
  color: #999999;
  margin-top: 28px;
  margin-bottom: 30px;
}
.container {
  width: 1200px;
  margin: 0 auto;
}
/*副导航兰*/
.title-tab {
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(102, 102, 102, 1);
  line-height: 54px;
  cursor: pointer;
}
.red {
  color: red;
}
.yi {
  margin-top: 20px;
}
/*问卷调查正文*/
.text {
  background-color: white;
  padding: 44px 60px 121px 60px;
  margin: 0 auto;
}
.text h1 {
  font-size: 28px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: rgba(51, 51, 51, 1);
  line-height: 56px;
  text-align: center;
}
.text h2 {
  font-size: 16px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(153, 153, 153, 1);
  line-height: 44px;
  text-align: center;
}
.text h3 {
  font-size: 16px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(51, 51, 51, 1);
  line-height: 32px;
  text-indent: 2em;
}
/*静态页面样式 */
.PIC-BOX {
  display: flex;
  justify-content: center;
}
.text h3 b {
  display: block;
  margin-top: 20px;
}
</style>